import Typography from "ds/components/Typography";

const TableCellEmpty = () => {
  return (
    <Typography variant="p-body3" tag="span">
      -
    </Typography>
  );
};

TableCellEmpty.displayName = "DS.Table.CellEmpty";

export default TableCellEmpty;
